import { ReactFlowSchema } from '@Types';

export const hasUnsetConnectorCondition = (
	label: string | undefined,
): boolean => {
	if (typeof label !== 'string' || label.trim().length === 0) {
		return true;
	}
	const condition = label.trim().split(/\s+/)[0]?.toUpperCase() ?? '';
	return condition !== 'TRUE' && condition !== 'FALSE';
};

export const getSourceTitleForConnectorError = (
	sourceNode: ReactFlowSchema | undefined,
	sourceId: string,
): string => {
	const nodeLabel = sourceNode?.label;
	if (typeof nodeLabel === 'string' && nodeLabel.length > 0) {
		return nodeLabel;
	}

	const dataLabel = sourceNode?.data?.label;
	if (typeof dataLabel === 'string' && dataLabel.length > 0) {
		return dataLabel;
	}

	return sourceId;
};

const hasEdgeSource = (element: ReactFlowSchema): boolean => {
	return (
		element.source !== undefined &&
		element.source !== null &&
		String(element.source).length > 0
	);
};

export const getUnsetConnectorConditionErrors = (
	elements: ReactFlowSchema[],
	startNodeId: string,
): { errorMessage: string }[] => {
	if (elements.length === 0) {
		return [];
	}

	const nodesById = new Map(
		elements
			.filter(element => element.position)
			.map(node => [String(node.id), node]),
	);
	const reportedSources = new Set<string>();
	const errorMessages: { errorMessage: string }[] = [];

	elements.filter(hasEdgeSource).forEach(edge => {
		const sourceId = String(edge.source);
		if (sourceId === startNodeId) {
			return;
		}
		const edgeLabel =
			typeof edge.label === 'string' ? edge.label : undefined;
		if (hasUnsetConnectorCondition(edgeLabel)) {
			if (!reportedSources.has(sourceId)) {
				const sourceNode = nodesById.get(sourceId);
				const sourceTitle = getSourceTitleForConnectorError(
					sourceNode,
					sourceId,
				);
				errorMessages.push({
					errorMessage: `tree query (${sourceTitle}) has a connection without a True/False condition`,
				});
				reportedSources.add(sourceId);
			}
		}
	});

	return errorMessages;
};
